<script>
import Loader from "./_Loader";
import moment from "@/utils/moment";

export default {
  props: {
    initialTime: {
      type: [Date, String],
      required: true
    }
  },

  components: {
    Loader
  },

  data() {
    return {
      time: null,
      interval: null
    };
  },

  methods: {
    countdown() {
      let eventTime = moment(this.initialTime)
          .add(20, "minutes")
          .unix(),
        currentTime = moment().unix(),
        diffTime = eventTime - currentTime,
        duration = moment.duration(diffTime * 1000, "milliseconds"),
        interval = 1000;

      if (diffTime <= 0) {
        clearInterval(this.interval);
        this.$emit("timeIsUp");
        return;
      }

      duration = moment.duration(
        duration.asMilliseconds() - interval,
        "milliseconds"
      );

      let m = moment.duration(duration).minutes(),
        s = moment.duration(duration).seconds();

      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;

      this.time = m + ":" + s;
    }
  },
  mounted() {
    this.interval = setInterval(this.countdown, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>

<template>
  <transition name="zoom" mode="out-in">
    <div v-if="time" class="countdown">
      <loader class="mr-10" />
      <div>
        <span>TEMPO RESTANTE</span>
        <h1>{{time}}</h1>
      </div>
    </div>
  </transition>
</template>

<style scoped>
section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

h2 {
  width: min-content;
  word-break: keep-all;
}

.cart {
  height: 65px;
}

.with-border {
  border-bottom: 1px solid #ddd;
}

.title,
.countdown {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.countdown div span {
  font-size: 14px;
}
.countdown div h1 {
  font-size: 45px;
  margin: 0;
}

@media (max-width: 768px) {
  section {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .countdown {
    flex-direction: row;
  }

  h2 {
    font-size: 24px;
  }

  .cart {
    height: 55px;
  }

  .countdown div span {
    font-size: 13px;
  }
  .countdown div h1 {
    font-size: 40px;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payment/Countdown.vue